import { memo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";

import { closeSharerFlowDialog } from "redux/actions/portal/flowsActionCreator";

const SharerFlowNotificationDialog = () => {
   const { showSharerFlowDialog, credentialsInSharedFlow } = useSelector((state) => state.portal.flows);
   const dispatch = useDispatch();
   const navigate = useNavigate();

   const closeDialog = () => {
      dispatch(closeSharerFlowDialog());
   };

   const gotoCredentialsManagement = () => {
      closeDialog();
      const pathname = window.location.pathname;

      if (pathname.includes("designer")) {
         window.open("/administration/credential-management", "_blank", "noreferrer");
         return;
      }
      navigate("/administration/credential-management");
   };

   return (
      <Dialog open={showSharerFlowDialog} onClose={closeDialog}>
         <DialogTitle>Share Credentials</DialogTitle>
         <DialogContent>
            The flow that you are sharing references these credentials:
            <ul style={{ marginLeft: "24px" }}>
               {credentialsInSharedFlow.map((credential) => (
                  <li key={credential.name}>
                     &quot;{credential.name}&quot; ({credential.type})
                  </li>
               ))}
            </ul>
            If you want to share some or all of these credentials as well, please do so in Credentials Management.
         </DialogContent>
         <DialogActions>
            <SoftButton variant="outlined" onClick={closeDialog}>
               Cancel
            </SoftButton>
            <SoftButton onClick={gotoCredentialsManagement} color="primary">
               Credentials Management
            </SoftButton>
         </DialogActions>
      </Dialog>
   );
};

export default memo(SharerFlowNotificationDialog);
